import { useAppDispatch, useAppSelector } from "hooks/redux";
import useReactHookForm from "hooks/useReactHookForm";
import { useEffect, useState } from "react";
import {
  updateStateLanguagePreInitialValues,
  updateStateLanguagePreMandatoryFields,
  updateStateLanguagePreValidationSchema,
  updateStateLanguageProperties,
} from "./helper";
import { Box, Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { metadataSuccess } from "app-component/slices/metadata-slice";
import { getGenericLanguageListData } from "utils/metadata-split/metaDataApiFetch";
import {
  getStatelanguagePrefListRequest,
  getUpdatePageStatelanguagePrefListRequest,
  languageChoiceListRequest,
  setFilterAfterUpdate,
} from "pages/configue/slices/language-preferance-slice";
import { useHistory, useRouteMatch } from "react-router-dom";
import { isEmpty } from "utils/helpers";
import LoadingButton from "@mui/lab/LoadingButton";
import configueService from "pages/configue/service";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";
import Loader from "pages/build-test/loader";

export const UpdateLanguagePre = () => {
  const [showSecondSection, setShowSecondSec] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    updateStateLanguagePreInitialValues,
    updateStateLanguagePreValidationSchema,
    ""
  );
  const dispatch = useAppDispatch();
  const match: any = useRouteMatch();
  const history = useHistory()

  const [triggerSetValue, setTriggerSetValue] = useState(false);
  const { isLoading: isLoad, data: metaData }: any = useAppSelector(
    (state) => state.metadataReducer
  );
  const { updatePageStateLangPrefList, loading }: any = useAppSelector(
    (state) => state.languagePreferanceSlice
  );
  const [showLoading, setShowIsLoading] = useState(true);

  const updateMetaData = (listData, metaKey) => {
    let metadataList = { ...metaData };
    metadataList[metaKey] = listData;
    dispatch(metadataSuccess(metadataList));
    setShowIsLoading(false);
  };

  const handleUpdateLangPref = async () => {
    try {
      setBtnLoading(true);
      const reqBody = {
        state_language_preference_id:
          match?.params?.state_language_preference_id,
        state_id: watch().state_id,
        board_id: watch().board_id,
        segment_id: watch().segment_id,
        class_id: watch().class_id,
        first_language_list: watch()?.first_language_list,
        second_language_list: watch()?.second_language_list,
        third_language_list: watch()?.third_language_list,
      };

      const res: any = await configueService.updateStateLanguagePreferance(
        reqBody
      );
      if (res?.status === 200 && res?.data?.status === "success") {
        dispatch(snackbarRequest({ message: res.data.message }));
        dispatch(setFilterAfterUpdate(reqBody));
        setBtnLoading(false);
         history.push(`/configue/language_preferance`)
      } else {
        setBtnLoading(false);
        dispatch(snackbarRequest({ message: res.data.message, type: "error" }));
      }
    } catch (error: any) {
      setBtnLoading(false);
      dispatch(
        snackbarRequest({
          message: error?.response?.data?.message,
          type: "error",
        })
      );
    }
  };

  useEffect(() => {
    setShowIsLoading(true);
    (async () => {
      try {
        const call1: any = await getGenericLanguageListData(updateMetaData);
        updateMetaData(call1[0], call1[1]);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      dispatch(
        getUpdatePageStatelanguagePrefListRequest({
          state_language_preference_id:
            match?.params?.state_language_preference_id,
        })
      );
    })();
  }, []);

  useEffect(() => {
    if (!isEmpty(updatePageStateLangPrefList)) {
      setValue("state_id", updatePageStateLangPrefList?.State);
      setValue("board_id", updatePageStateLangPrefList?.Board);
      setValue("segment_id", updatePageStateLangPrefList?.Segment);
      setValue("class_id", updatePageStateLangPrefList?.Class);
      setValue(
        "first_language_list",
        updatePageStateLangPrefList?.FirstLanguages
      );
      setValue(
        "second_language_list",
        updatePageStateLangPrefList?.SecondLanguages
      );
      setValue(
        "third_language_list",
        updatePageStateLangPrefList?.ThirdLanguages
      );
    }
  }, [updatePageStateLangPrefList]);

  if (showLoading) {
    return <Loader />;
  }
  if (!showLoading && loading) {
    return <Loader />;
  }

  return (
    <>
      <TypographyHeading>Update Language Preference</TypographyHeading>
      <Box>
        <Paper elevation={2} sx={{ px: 2, pb: 2, marginTop: "10px" }}>
          <Grid container spacing={2}>
            <DynamicForm
              fields={updateStateLanguageProperties}
              control={control}
              errors={errors}
              getValues={getValues}
              setValue={setValue}
              watch={watch}
            />
            <ContentRight sx={{ mt: -7 }}>
              <LoadingButton
                variant="contained"
                loadingPosition="start"
                loading={btnLoading}
                sx={{
                  width: "120px",
                  height: "40px",
                  marginTop: "15px",
                  marginRight: "10px",
                  padding: "7px 42.5px 7px 48.5px",
                  cursor: "pointer",
                  textAlign: "center",
                }}
                onClick={handleUpdateLangPref}
                disabled={
                  !isFieldsValidate(
                    errors,
                    updateStateLanguagePreMandatoryFields,
                    getValues
                  )
                }
              >
                Update
              </LoadingButton>
            </ContentRight>
          </Grid>
        </Paper>
      </Box>
    </>
  );
};
